/* Forces the brand fonts onto Globo's form markup.
   The app does not declare its font server-side. It fetches the form config at
   runtime and injects its own style after our stylesheet, so a class-based rule
   in globo-brand.css can lose the race no matter how specific it is. Setting the
   property inline with important puts it at the top of the cascade, where only
   another inline important could beat it, and re-applying on mutation covers the
   app re-rendering a step of the wizard.

   Fonts come from the CSS custom properties, so if the Cusion and Serial B Neue
   licences land and tokens.css changes, this follows with no edit. */
(function () {
  var root = document.documentElement;
  function token(name, fallback) {
    var v = getComputedStyle(root).getPropertyValue(name);
    return (v && v.trim()) || fallback;
  }
  var DISPLAY = token('--font-display', '"Baloo 2", "Arial Black", sans-serif');
  var BODY = token('--font-body', 'Inter, Helvetica, Arial, sans-serif');

  var DISPLAY_SEL = 'label, .globo-label, .label-content, button, .classic-button, .wizard__submit, .message.success';
  var BODY_SEL = 'input, textarea, select, p, span:not(.label-content), div, .globo-option, .error';

  function apply(scope) {
    scope.querySelectorAll(DISPLAY_SEL).forEach(function (el) {
      el.style.setProperty('font-family', DISPLAY, 'important');
    });
    scope.querySelectorAll(BODY_SEL).forEach(function (el) {
      // Do not fight the display rule where a label wraps the text in a span
      if (el.closest('label, button, .classic-button')) return;
      el.style.setProperty('font-family', BODY, 'important');
    });
  }

  function sweep() {
    document.querySelectorAll('.globo-form-app').forEach(apply);
  }

  if (document.readyState !== 'loading') sweep();
  document.addEventListener('DOMContentLoaded', sweep);

  // The app mounts and re-renders asynchronously, so watch for it.
  var pending = null;
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      if (records[i].addedNodes && records[i].addedNodes.length) {
        clearTimeout(pending);
        pending = setTimeout(sweep, 60);
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
